
import { defineComponent, PropType } from 'vue';

import { useCreatedDevAccount } from '../composables/index';
import {
  IAccountInfoLogs,
} from '@/api/manage-app/account-info/index.d';

export default defineComponent({
  name: 'DevAccountLogs',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    gridData: {
      type: Array as PropType<IAccountInfoLogs[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const {
      tableLoading,
      handleLogClose,
    } = useCreatedDevAccount({}, emit);

    return {
      tableLoading,
      handleLogClose,
    };
  },
});
